module.exports = __webpack_public_path__ + "static/greywaffle-85a09304c0890dfc720401af74a78e95.jpeg";